import { useEffect } from 'react';

import { useUser } from '@clerk/react';

import { useComposeSnapshotIndexStore } from '../store/ComposeSnapshotIndex';
import { listDirtyComposeSnapshots } from '../store/utils/composeSnapshotCache';
import { VISIBILITY_VISIBLE } from '../utils/constants/uiConstants';

const VISIBILITY_CHANGE_EVENT = 'visibilitychange';

export const useComposeSnapshotIndexHydration = (): void => {
  const { user } = useUser();
  const userId = user?.id;

  useEffect(() => {
    if (!userId) {
      return undefined;
    }
    let isCancelled = false;
    const hydrate = async () => {
      const snapshots = await listDirtyComposeSnapshots(userId);
      if (!isCancelled) {
        useComposeSnapshotIndexStore.getState().hydrate(userId, snapshots);
      }
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === VISIBILITY_VISIBLE) {
        void hydrate();
      }
    };
    void hydrate();
    document.addEventListener(VISIBILITY_CHANGE_EVENT, handleVisibilityChange);
    return () => {
      isCancelled = true;
      document.removeEventListener(
        VISIBILITY_CHANGE_EVENT,
        handleVisibilityChange,
      );
    };
  }, [userId]);
};
